export default "__VITE_ASSET__Bfu5M2Nf__"